import React from "react";
import CumulativeInterestChart from "./CumulativeInterestChart";
import styles from "./MyAssetsCards.module.css";

/**
 * Card showing "Cumulative Interest Earned": total USDi and a chart of cumulative interest
 * by month (total interest from start to end of each month), with x-axis labels like Sep '24, Oct '24.
 */
function CumulativeInterestCard({
  cumulativeTotal,
  swapMainWalletAddress,
  isLoading,
}) {
  const totalNum =
    cumulativeTotal != null && Number.isFinite(Number(cumulativeTotal))
      ? Number(cumulativeTotal).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      : "—";

  return (
    <div className={`${styles.card} ${styles.tableCard} ${styles.chartCard}`}>
      <div className={styles.chartCardHeader}>
        <h3 className={styles.tableCardTitle}>Cumulative Interest Earned</h3>
        <div className={styles.chartCardTotal}>
          <span className={styles.chartCardTotalValue}>{totalNum}</span>
          <span className={styles.chartCardTotalLabel}>USDi Total</span>
        </div>
      </div>
      <div className={styles.chartContainer}>
        <CumulativeInterestChart
          walletAddress={swapMainWalletAddress}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
}

export default CumulativeInterestCard;
